import SVG from '../SVG';
import * as S from './styled';
export interface ButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  loading?: boolean;
}

export default Object.assign(
  ({
    children,
    className = '',
    loading = false,
    ...rest
  }: ButtonProps) => {
    return (
      <S.Button className={`${className}`} {...rest}>
        {!loading ? (
          children
        ) : (
          <SVG.Icon.Loader
            style={{
              margin: 0,
              height: 24,
            }}
            color="white"
            width={33}
            height={33}
          />
        )}
      </S.Button>
    );
  },
  {},
);
